import cached from 'utils/cached';
// import pendingPromise from './pendingPromise';

const isWebPSupported = cached(() => {
	if (typeof window === 'undefined') {
		return;
	}
	let elem = document.createElement('canvas');
	return elem?.toDataURL('image/webp')?.startsWith('data:image/webp');

	// Ideally should use this but need to change everything using it to be async
	// let promise = pendingPromise();
	// let img = new Image();
	// img.onload = () => promise.resolve(!!img.width);
	// img.onerror = () => promise.resolve(false);
	// img.src = 'data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==';
	// return promise;
});

export { isWebPSupported };